export const initialDDLProviderProps = {
  historyLimit: 20,
  history: [],
  subscribers: {},
  ddl: {
    campaigns: [],
    charset: 'UTF-8',
    components: [
      {
        componentId: 'amex-connect-root',
        version: '1.5.0',
        impressed: true,
        timestamp: new Date().toISOString(),
      },
    ],
    device: {},
    events: [
      {
        timestamp: new Date().toISOString(),
      },
    ],
    version: '1.7.0',
    timestamp: new Date().toISOString(),
    user: {
      publicGuid: '1234567890',
    },
    view: {
      viewId: 'en-us/amex-connect-root',
      timestamp: new Date().toISOString(),
      origin: 'https://qwww.americanexpress.com',
      locale: 'en-US',
      language: 'en',
      country: 'US',
      location: 'https://qwww.americanexpress.com/en-us/account/login',
      referrer: 'https://qwww.americanexpress.com/en-us/account/logout',
      title: 'Logout',
    },
    diff: [
      'events',
      'view',
      'charset',
    ],
  },
};
